var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch43A0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.925,
    height: 14.207,
    viewBox: "0 0 14.925 14.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(0 13.079) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2468",
    "data-name": "Rectangle 2468",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f47341",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.079,
    height: 13.381,
    rx: 6.539,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 11.479,
    height: 11.781,
    rx: 5.739,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M2.47,0,0,2.842",
    transform: "translate(0 10.955)",
    fill: "none",
    stroke: "#f47341",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch43A0);
export default __webpack_public_path__ + "static/media/search43a0.917390aaf4cf695d6d9b3116336f1d80.svg";
export { ForwardRef as ReactComponent };